import { useEffect } from 'react';
import { DestinationMap, useUpdateDestinationMap } from '../impl';
import { useDeepCompare } from '../../../../hooks/useCompare';

// PluginProps are equal to DestinationMap for the time being, but this is likely to change soon
interface PluginProps extends DestinationMap {}

// Declare the type to make sure that null is returned
type DataTablePluginComponent = (props: PluginProps) => null;

export const BasePlugin: DataTablePluginComponent = (props) => {
  const update = useUpdateDestinationMap();

  const propsHasChanged = useDeepCompare(props);

  // Update plugin state
  useEffect(() => {
    if (propsHasChanged) {
      update(props);
    }
  }, [props, propsHasChanged, update]);

  // Returns null to hide it from DOM
  return null;
};
